export default __webpack_public_path__ + "83d6c549c40e28efa07fdfde86f746e2.png";